import React from 'react';

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      activeIndex: 0
    };
  }

  componentDidMount() {
    let newSlides = React.Children.toArray(this.props.children);

    this.setState({
      data: newSlides
    });
  }

  callOnChange = currentIndex => {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(currentIndex);
    }
  };

  goNext = async () => {
    this.setState(prevState => {
      const { activeIndex, data } = prevState;

      const nextIndex = activeIndex === data.length - 1 ? 0 : activeIndex + 1;
      this.callOnChange(nextIndex);
      return {
        activeIndex: nextIndex
      };
    });
  };

  goPrev = () => {
    this.setState(prevState => {
      const { activeIndex, data } = prevState;

      const nextIndex = activeIndex === 0 ? data.length - 1 : activeIndex - 1;
      this.callOnChange(nextIndex);
      return {
        activeIndex: nextIndex,
        transition: 'transform 500ms ease-in-out'
      };
    });
  };

  render() {
    const { activeIndex, data } = this.state;
    const { className } = this.props;
    return (
      <div className={`live-classes-carousel-container ${className}`}>
        {data.map((child, index) => {
          return React.cloneElement(child, {
            style: {
              transform: `translateX(${-activeIndex * 100}%)`,
              transition: 'transform 500ms ease-in-out'
            },
            key: `${child}-${index}`
          });
        })}
        <div className="live-classes-carousel-actions">
          <button className="carousel-actions" onClick={this.goPrev}>
            PREV
          </button>
          <button className="carousel-actions" onClick={this.goNext}>
            NEXT
          </button>
        </div>
      </div>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ./src/Pages/LiveClass/Carousel.js